import { unified } from "unified";
import remarkGfm from "remark-gfm";
import remarkHtml from "remark-html";
import remarkParse from "remark-parse";

/**
 * Converts markdown text to HTML using unified processor
 * @param markdown - The markdown string to convert
 * @returns Promise<string> - The converted HTML string
 */
const markdownProcessor = unified()
  .use(remarkParse)
  .use(remarkGfm)
  .use(remarkHtml);

export const convertMarkdownToHtml = async (
  markdown: string,
): Promise<string> => {
  const result = await markdownProcessor.process(markdown);
  return result.toString();
};
